/* istanbul ignore file */

import CreatePresaleOutputForm from 'domain/sales/opportunity/presale/output/form/CreatePresaleOutputForm';
import UpdatePresaleOutputForm from 'domain/sales/opportunity/presale/output/form/UpdatePresaleOutputForm';
import PresaleOutputTimelineRecordLayout from 'domain/sales/opportunity/presale/output/PresaleOutputTimelineRecordLayout';
import { CREATE_PRESALE_OUTPUT, PRESALE_ITEMS_TYPE } from 'domain/sales/opportunity/opportunityService';
import type { Data } from 'framework/types';
import { TimelineItem } from 'framework/ui/timeline';

const usePresaleOutputItem = () => ({
  AddForm: CreatePresaleOutputForm,
  UpdateForm: UpdatePresaleOutputForm,
  isApplicable: (item: any) => item?.presaleOutput,
  source: 'presaleOutput',
  urlPostfix: PRESALE_ITEMS_TYPE.PRESALE_OUTPUT,
  RecordLayout: PresaleOutputTimelineRecordLayout,
  name: 'Presale Output',
  permissionToCheck: CREATE_PRESALE_OUTPUT,
  additionalAfterAddSubmit: (item: TimelineItem, parentContext?: Data) => {
    const oppState = parentContext?.getValueBySource('stateStep');
    if (oppState === 'PRESALE') {
      window.location.reload(); // reload page for fetch actual state
    }
  },
});

export default usePresaleOutputItem;
